import App from 'App';
import MainLayout from 'layouts/MainLayout';
import Error404 from 'pages/error/Error404';
import SimpleForgotPassword from 'pages/pages/authentication/simple/ForgotPassword';
import {
  default as ResetPassword,
  default as SimpleResetPassword
} from 'pages/pages/authentication/simple/ResetPassword';
import SimpleSignIn from 'pages/pages/authentication/simple/SignIn';
import SimpleSignOut from 'pages/pages/authentication/simple/SignOut';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';

import ClinicMyAccount from 'pages/clinic/account/ClinicMyAccount';
import AddPatient from 'pages/clinic/patient/AddPatient';
import Patient from 'pages/clinic/patient/Patient';
import PatientList from 'pages/clinic/patient/PatientList';

import SAAddClinic from 'pages/superadmin/clinic/AddClinic';
import Clinics from 'pages/superadmin/clinic/Clinics';
import SAEditClinic from 'pages/superadmin/clinic/EditClinic';
import ECharts from 'pages/modules/charts/ECharts';

import PrivacyPolicy from './pages/pages/static/PrivacyPolicy';
import ContactUs from './pages/pages/static/ContactUs';
import TermsOfService from './pages/pages/static/TermsOfService';
import HowWeWorks from './pages/pages/static/HowWeWorks';
import EditPatient from 'pages/clinic/patient/EditPatient';
import UploadPatientReport from 'pages/clinic/patient/UploadPatientReport';
import PatientDailyProgress from 'pages/clinic/patient/PatientDailyProgress';
import UploadPrescription from 'pages/clinic/patient/UploadPrescription';
import UploadGoals from 'pages/clinic/patient/goals/UpdateGoals';
import GoalsList from 'pages/clinic/patient/goals/GoalsList';
import FaqAccordion from 'pages/faq/FaqAccordion';
import Alternate from 'pages/pages/landing/Alternate';
import FoodImport from 'pages/superadmin/food/FoodImport';
import FoodList from 'pages/superadmin/food/FoodList';
import AddFood from 'pages/superadmin/food/AddFood';

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: <Alternate />
      },
      {
        path: '',
        element: (
          <MainLayoutProvider>
            {' '}
            <MainLayout />{' '}
          </MainLayoutProvider>
        ),
        children: [
          {
            path: 'clinic',
            children: [
              {
                path: '',
                element: <Navigate to="patient/list" replace />
              },
              {
                path: 'patient/list',
                element: <PatientList />
              },
              {
                path: 'patient/add',
                element: <AddPatient />
              },
              {
                path: 'patient/:id',
                element: <Patient />,
                children: [
                  {
                    path: '',
                    element: <Navigate to="profile" replace />
                  },
                  {
                    path: 'profile',
                    element: <EditPatient />
                  },
                  {
                    path: 'reports',
                    element: <UploadPatientReport />
                  },
                  {
                    path: 'food-data',
                    element: <PatientDailyProgress />
                  },
                  {
                    path: 'meal-plan',
                    element: <UploadPrescription />
                  },
                  {
                    path: 'goals',
                    children: [
                      {
                        path: 'weight',
                        element: <GoalsList />
                      },
                      {
                        path: 'hba1c',
                        element: <GoalsList />
                      }
                    ]
                  }
                ]
              },
              {
                path: 'my-account',
                element: <ClinicMyAccount />
              }
            ]
          },
          {
            path: 'superadmin',
            children: [
              {
                path: '',
                element: <Navigate to="clinic/list" replace />
              },
              {
                path: 'clinic/list',
                element: <Clinics />
              },
              {
                path: 'clinic/add',
                element: <SAAddClinic />
              },
              {
                path: 'clinic/edit/:id',
                element: <SAEditClinic />
              },
              {
                path: 'food/import',
                element: <FoodImport />
              },
              {
                path: 'food',
                element: <FoodList />
              },
              {
                path: 'food/list',
                element: <FoodList />
              },
              {
                path: 'food/:id',
                element: <FoodList />
              },
              {
                path: 'food/add',
                element: <AddFood />
              },
              {
                path: 'food/:id/edit',
                element: <AddFood />
              }
              // {
              //   path: 'my-account',
              //   element: <SAMyAccount />
              // },
            ]
          }
        ]
      },
      {
        path: '/auth/',
        children: [
          {
            path: 'login',
            element: <SimpleSignIn />
          },
          {
            path: 'reset/:token',
            element: <ResetPassword />
          },
          {
            path: 'logout',
            element: <SimpleSignOut />
          },
          {
            path: 'forgot-password',
            element: <SimpleForgotPassword />
          },
          {
            path: 'reset-password',
            element: <SimpleResetPassword />
          }
        ]
      },
      {
        path: 'terms-of-service',
        element: <TermsOfService />
      },
      {
        path: 'how-we-works',
        element: <HowWeWorks />
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />
      },
      {
        path: 'contact-us',
        element: <ContactUs />
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
];

export const router = createBrowserRouter(routes);

export default routes;
